import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import ServiceCard from "../components/ServiceCard";
import CTABand from "../components/CTABand";
import { Stagger, StaggerItem } from "../components/Reveal";
import { SERVICES, CONDITIONS } from "../data/site";
import { breadcrumbSchema } from "../lib/schema";

export default function Services() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
  ];
  return (
    <>
      <SEO
        title="Online Therapy Services in NJ | Telehealth Counseling"
        description="Telehealth counseling across New Jersey: individual, teen, couples, family and child therapy, EMDR, art therapy and clinical assessments. In-network, secure video."
        path="/services"
        schema={breadcrumbSchema(crumbs)}
      />
      <PageHero
        crumbs={crumbs}
        eyebrow="Services"
        title="Online therapy services for"
        accent="New Jersey"
        underline
        body="Every service is delivered over secure, HIPAA-compliant video by licensed clinicians, for anyone located in New Jersey."
        testid="services-hero"
      />
      <section className="section" data-testid="services-grid">
        <div className="container-site">
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {SERVICES.map((s) => (
              <StaggerItem key={s.slug} className="h-full">
                <ServiceCard service={s} headingLevel="h2" />
              </StaggerItem>
            ))}
          </Stagger>

          <div className="mt-16">
            <h2 className="text-2xl md:text-3xl">Therapy for common concerns</h2>
            <Stagger className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {CONDITIONS.map((c) => (
                <StaggerItem key={c.slug} className="h-full"><Link to={`/conditions/${c.slug}`} className="card card-hover block h-full p-6" data-testid={`condition-card-${c.slug}`}>
                  <h3 className="text-lg">{c.title} Therapy</h3>
                  <p className="mt-2 text-sm text-body leading-relaxed">{c.short}</p>
                </Link></StaggerItem>
              ))}
            </Stagger>
          </div>
        </div>
      </section>
      <CTABand />
    </>
  );
}
